
import { Vue, Component } from "vue-property-decorator"
import AppPage from "@/components/layout/AppPage.vue"
import TasksWidget from "@/components/tasks/TasksWidget.vue"

@Component({ components: { AppPage, TasksWidget } })
export default class Tasks extends Vue {}
